import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { CompanyDetailsTab } from "./tabs/CompanyDetailsTab";

function B2BRentalsPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <CompanyDetailsTab />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default B2BRentalsPage;
